require('./transfersTableRow.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
const PropTypes = require('prop-types');

//@core
const { getLanguage } = require('core/i18n').i18n;

// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LabelDate } = require('commonsComponents/labelDate');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKCollapsingToggler } = require('commonsComponents/OKCollapsingToggler');

// @ constants
const { HYPHEN } = require('constants/index');
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');


class TransfersTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.onRowClick = this.onRowClick.bind(this);
    }

    onRowClick() {
        const { id, onRowClick } = this.props;
        onRowClick(id);
    }

    render() {
        const {
            id,
            immTransaction,
            immScreen,
            isExpanded,
        } = this.props;
        
        const beneficiaryClass = classNames(
            'transfers-table-row__beneficiary',
            {
                'transfers-table-row__beneficiary--highlighted': isExpanded
            }
        );
        const plainAmountObject = getPlainAmountObject(immTransaction.get('amount'));
        const language = getLanguage();
        const dateCell = (
            <LabelDate
                date={immTransaction.get('date')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        );
        const amountCell = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );

        let tableRow;

        if (immScreen.get('isMobile')) {
            const mobileDetailNoMargin = classNames(
                "scheduled-transfers-table-row__detail-mobile",
                "scheduled-transfers-table-row__detail-mobile--no-margin"
            );

            tableRow = (
                <OKTableRow id={id} isExpanded={isExpanded}>
                    <OKTableCell className="scheduled-transfers-table-row__expand-cell-mobile">
                        <OKCollapsingToggler handlerToggle={this.onRowClick} isExpanded={isExpanded} isIconSecondary={true} />
                    </OKTableCell>
                    <OKTableCell>
                        <p className="scheduled-transfers-table-row__detail-mobile">
                            {dateCell}
                        </p>
                        <p className={mobileDetailNoMargin}>
                            {immTransaction.get('beneficiaryName')}
                        </p>
                        <p className={mobileDetailNoMargin}>
                            {amountCell}
                        </p>
                    </OKTableCell>
                </OKTableRow>
            );
        } else {
            tableRow = (        
                <OKTableRow id={id} isExpanded={isExpanded}>
                    <OKTableCell>
                        <OKCollapsingToggler handlerToggle={this.onRowClick} isExpanded={isExpanded} isIconSecondary={true} />
                    </OKTableCell>
                    <OKTableCell className="transfers-table-row__date">
                        {dateCell}
                    </OKTableCell>
                    <OKTableCell className={beneficiaryClass}>
                        {immTransaction.get('beneficiaryName')}
                    </OKTableCell>
                    <OKTableCell className="transfers-table-row__description">
                        {immTransaction.get('concept') || HYPHEN}
                    </OKTableCell>
                    <OKTableCell className="transfers-table-row__amount">
                        {amountCell}
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return tableRow;
    }
}

TransfersTableRow.propTypes = {
    id: PropTypes.string.isRequired,
    immTransaction: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    isExpanded: PropTypes.bool,
    isExpandable: PropTypes.bool,
    onRowClick: PropTypes.func,
}

TransfersTableRow.defaultProps = {
    onRowClick: function () { }
}

module.exports.constructor = TransfersTableRow;
module.exports = connect(
    state => ({
        immScreen: state.screen,
    }), null)(TransfersTableRow);
